var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"images-title"},[_vm._v("Images")]),_c('div',{staticClass:"select-images-gallery"},_vm._l((_vm.images),function(image){return _c('div',{key:image.filename,staticClass:"blog_post_paragraphs_order__img"},[_c('img',{attrs:{"src":image.shareable_url,"alt":image.description}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }